// extracted by mini-css-extract-plugin
module.exports = {"vacationsDesc":"ModalForm_vacationsDesc__1G3sW"};